import axios from 'axios';

const SUPPORTER_API = '/api/media_follow.php?m=status&company_id=';

/**
 * 企業IDを受け取ってポップアップに必要なレスポンスを返す
 * @param {string} companyId 企業ID
 */
export const fetchCompleteType = (companyId) => {
  return axios({
    url: `${SUPPORTER_API}${companyId}`
  }).then(res => {
    return res.data;
  });
};
